<template>
  <div class="interPoolTable">
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button @click="save()" type="primary" class="vxe-btn-primary">{{
          $t('advanced.btnList.save')
        }}</vxe-button>
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="interPoolTable"
      class="vxe-table-element"
      size="mini"
      align="left"
      :loading="load"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
      :edit-rules="rules"
      :edit-config="{ trigger: 'click', mode: 'row' }"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import API from '@/api/capitalCenter/moneyDraw';

  export default {
    name: 'interPoolTable',
    props: {
      tabItem: {
        type: Object,
      },
    },
    components: {},
    data() {
      return {
        tableData: [],
        load: false,
        companyOptions: [],
      };
    },
    computed: {
      //基础数据表单配置
      columnList() {
        return [
          {
            field: 'interestDate',
            title: this.$t('advanced.poolTable.interestDate'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'orderId',
            title: this.$t('advanced.poolTable.orderId'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          ...this[this.tabItem.optionName],
          {
            field: 'orderCompanyCode',
            title: this.$t('advanced.poolTable.orderCompanyCode'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'orderCompanyName',
            title: this.$t('advanced.poolTable.orderCompanyName'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'orderDepartmentCode',
            title: this.$t('advanced.poolTable.orderDepartmentCode'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'orderDepartmentName',
            title: this.$t('advanced.poolTable.orderDepartmentName'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'remark',
            title: this.$t('advanced.poolTable.remark'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
        ];
      },
      // 现金
      cashList() {
        return [
          {
            field: 'interestPaymentAmount',
            title: this.$t('advanced.poolTable.interestPaymentAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'interestReceiptAmount',
            title: this.$t('advanced.poolTable.interestReceiptAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
        ];
      },
      // 票据
      billList() {
        return [
          {
            field: 'billType',
            title: this.$t('advanced.billTable.billType'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'billNo',
            title: this.$t('advanced.interBillTable.billNo'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'interestAmount',
            title: this.$t('advanced.interBillTable.interestAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'endorseDepartmentCode',
            title: this.$t('advanced.interBillTable.endorseDepartmentCode'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'endorseDepartmentName',
            title: this.$t('advanced.interBillTable.endorseDepartmentName'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'endorseAmount',
            title: this.$t('advanced.interBillTable.endorseAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'duePaymentDate',
            title: this.$t('advanced.interBillTable.duePaymentDate'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
        ];
      },
      // 信用证
      CLList() {
        return [
          {
            // 业务单据代码
            field: 'orderCode',
            title: this.$t('advanced.interCLTable.orderCode'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'internationalClAmount',
            title: this.$t('advanced.interCLTable.internationalClAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'internationalPayAmount',
            title: this.$t('advanced.interCLTable.internationalPayAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'domesticClAmount',
            title: this.$t('advanced.interCLTable.domesticClAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'domesticPayAmount',
            title: this.$t('advanced.interCLTable.domesticPayAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
        ];
      },
      // 贸易融资
      TFList() {
        return [
          {
            field: 'orderAmount',
            title: this.$t('advanced.poolTable.interestAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
        ];
      },
      rules() {
        return {};
      },
    },
    methods: {
      async getData(eventOrderId) {
        let name = this.tabItem.name;
        let api = '';
        if (name == 'cash') {
          api = 'QUERY_INTERSTCASH';
        }
        if (name == 'bill') {
          api = 'QUERY_INTERSTBILL';
        }
        if (name == 'CL') {
          api = 'QUERY_INTERSTCL';
        }
        if (name == 'TF') {
          api = 'QUERY_INTERSTTF';
        }
        if (eventOrderId) {
          this.load = true;
          let res = await this.$axios.post(API[api], { eventOrderId });
          if (res) {
            this.load = false;
            if (res.data.code === 0) {
              this.tableData = res.data.data;
              this.tableData.map((item) => {
                if (!item.eventDesc) {
                  item.eventDesc = null;
                }
              });
            }
          }
        } else {
          this.tableData = [];
        }
      },
      async save() {
        let res = await this.exportChildData();
        if (res) {
          let params = {
            ...res,
          };
          this.saveData(params);
        }
      },
      async saveData(params) {
        let name = this.tabItem.name;
        let api = '';
        if (name == 'cash') {
          api = 'SAVE_INTERSTCASH';
        }
        if (name == 'bill') {
          api = 'SAVE_INTERSTBILL';
        }
        if (name == 'CL') {
          api = 'SAVE_INTERSTCL';
        }
        if (name == 'TF') {
          api = 'SAVE_INTERSTTF';
        }
        this.loading.startLoading();
        let res = await this.$axios.post(API[api], params);
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: res.data.msg,
            });
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        }
      },
      // 返回数据
      exportChildData() {
        const item = this.$refs.interPoolTable.getTableData().fullData[0];
        // 点击提交，走校验
        return new Promise((resolve) => {
          this.$refs.interPoolTable.validate((valid) => {
            if (valid) {
              let param = {
                ...item,
              };
              resolve(param);
            }
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped></style>
